<template>
    <v-col cols="12" :md="md">
        <v-card-title style="color:#213B87; font-size: 12pt">
            {{label}}
        </v-card-title>
        <v-card-subtitle>
            {{text}}
        </v-card-subtitle>
    </v-col>
</template>

<script>
    export default {
        name: "infoInput",
        props: ['md', 'label', 'text']
    }
</script>

<style scoped>

</style>